import { render, staticRenderFns } from "./app.vue?vue&type=template&id=3e3211d3&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=3e3211d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3211d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/magonxesp/repos/RandomAnimePicker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3211d3')) {
      api.createRecord('3e3211d3', component.options)
    } else {
      api.reload('3e3211d3', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=3e3211d3&scoped=true&", function () {
      api.rerender('3e3211d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/app/app.vue"
export default component.exports